import { configureStore } from '@reduxjs/toolkit';
import { ruleMiddleware } from 'reg_redesign/redux/middleware';
import getInitialState from 'reg_redesign/initialState';
import reducer from 'reducers/reducer';

export const store = configureStore({
  reducer,
  devTools: true,
  preloadedState: getInitialState(),
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(ruleMiddleware);
  }
});
